import {
  ContactAddressEditFormValues,
  ContactAddressSearchFormValues,
  ContactDetailFormValues,
  ContactEditFormValues,
  ContactEmailEditFormValues,
  ContactEmailSearchFormValues,
  ContactExportFormValues,
  ContactGroupEditFormValues,
  ContactImportFormValues,
  ContactImportXlsFormValues,
  ContactNoteEditFormValues,
  ContactNoteSearchFormValues,
  ContactPhoneEditFormValues,
  ContactPhoneSearchFormValues,
  ContactPictureFormValues,
  ContactRelationEditFormValues,
  ContactSearchFormValues,
  ContactType,
} from "./types";

/*-------------------------------------------------------------------------------------------
  CONTACT EDIT
---------------------------------------------------------------------------------------------*/

export const initialContactEditForm: ContactEditFormValues = {
  contactGroupIds: null,
  contactTypeId: null,
  firstName: null,
  lastName: null,
  companyName: null,
  jobTitle: null,
  department: null,
  personalIdentificationNumber: null,
  pictures: [],
};

/*-------------------------------------------------------------------------------------------
  CONTACT EDIT PHOTOS
---------------------------------------------------------------------------------------------*/

export const initialContactPictureForm: ContactPictureFormValues = {
  name: "",
  files: [],
};

/*-------------------------------------------------------------------------------------------
  CONTACT SEARCH
---------------------------------------------------------------------------------------------*/
export const initialContactSearchForm: ContactSearchFormValues = {
  search: "",
  contactTypeId: null,
  contactGroupIds: [],
  email: "",
  phone: "",
  address: "",
};

/*-------------------------------------------------------------------------------------------
  CONTACT DETAILS
---------------------------------------------------------------------------------------------*/

export const initialContactDetailForm: ContactDetailFormValues = {
  contactType: null,
  contactGroups: [],
  firstName: null,
  lastName: null,
  companyName: null,
  jobTitle: null,
  department: null,
  personalIdentificationNumber: null,
  pictures: []
};

/*-------------------------------------------------------------------------------------------
  CONTACT TYPES
---------------------------------------------------------------------------------------------*/
export const initialContactTypes: ContactType[] = [
  {
    id: "C",
    name: "Tvrtka",
  },
  {
    id: "P",
    name: "Osoba",
  },
];

/*-------------------------------------------------------------------------------------------
  CONTACT EMAILS
---------------------------------------------------------------------------------------------*/

export const initialContactEmailSearchForm: ContactEmailSearchFormValues = {
  search: "",
};

export const initialContactEmailEditForm: ContactEmailEditFormValues = {
  emailAddress: null,
  description: null,
  primary: false,
};

/*-------------------------------------------------------------------------------------------
  CONTACT PHONES
---------------------------------------------------------------------------------------------*/
export const initialContactPhoneSearchForm: ContactPhoneSearchFormValues = {
  search: "",
};

export const initialContactPhoneEditForm: ContactPhoneEditFormValues = {
  phoneTypeId: "M",
  phoneNumber: null,
  description: null,
  primary: false,
};

/*-------------------------------------------------------------------------------------------
  CONTACT ADDRESS
---------------------------------------------------------------------------------------------*/
export const initialContactAddressSearchForm: ContactAddressSearchFormValues = {
  search: "",
};

export const initialContactAddressEditForm: ContactAddressEditFormValues = {
  city: null,
  country: null,
  line1: null,
  line2: null,
  postalCode: null,
  state: null,
  description: null,
  primary: false,
  latitude: null,
  longitude: null,
};

/*-------------------------------------------------------------------------------------------
  CONTACT NOTE
---------------------------------------------------------------------------------------------*/
export const initialContactNoteSearchForm: ContactNoteSearchFormValues = {
  search: "",
};

export const initialContactNoteEditForm: ContactNoteEditFormValues = {
  content: null,
  important: false,
};

/*-------------------------------------------------------------------------------------------
  CONTACT IMPORT
---------------------------------------------------------------------------------------------*/

export const initialContactImportForm: ContactImportFormValues = {};

/*-------------------------------------------------------------------------------------------
  CONTACT IMPORT
---------------------------------------------------------------------------------------------*/

export const initialContactExportForm: ContactExportFormValues = {};

/*-------------------------------------------------------------------------------------------
  CONTACT GROUP
---------------------------------------------------------------------------------------------*/

export const initialContactGroupEditForm: ContactGroupEditFormValues = {
  name: null,
};

/*-------------------------------------------------------------------------------------------
  CONTACT IMPORT
---------------------------------------------------------------------------------------------*/

export const initialContactImportXlsEditForm: ContactImportXlsFormValues = {
  name: null,
  files: [],
};

/*-------------------------------------------------------------------------------------------
    CONTACT REPRESENTATIVE
  ---------------------------------------------------------------------------------------------*/

export const initialContactRepresentativeEditForm: ContactRelationEditFormValues = {
  personContactId: null,
};
